<template>
  <div>
    <navigation />
    <topnav />
    <div class="edittask-container">
      <div class="baseinfo">
        <form v-on:submit.prevent="editTask">
          <div>
            <p>
              <span>任务名：</span>
              <input v-model="taskName" required maxlength="80" placeholder="请输入任务名，80字以内" />
            </p>
            <p>
              <span>行业：</span>
              <select v-model="industryId" required
                ><option v-for="i of industries" :key="i.industryId" :value="i.industryId">{{
                  i.industryName
                }}</option></select
              >
              <span style="margin-left: 120px;">标注方式：</span>
              <select v-model="taskTypeId" required
                ><option v-for="type of taskTypes" :key="type.taskTypeId" :value="type.taskTypeId">{{
                  type.taskTypeName
                }}</option></select
              >
            </p>
            <p>
              <span style="vertical-align: top;">任务描述：</span>
              <textarea v-model="desc" maxlength="500" placeholder="请输入任务描述，500字以内"></textarea>
            </p>
            <p>
              <span>图片存储路径：</span>
              <input id="image-path" v-model="data" required />
            </p>
            <div>
              <p>
                <span>图片：</span>
              </p>
              <input
                type=""
                name=""
                v-model="imageIds"
                style="background: #fff;padding: 12px;border: 1px solid #ddd;border-radius: 4px;display: inline-block;width: 804px"
              />
            </div>
            <div>
              <p>
                <span>任务薪资(元)：</span>
                <el-switch v-model="customSalary" active-text="自定义" inactive-text="默认" active-color="#5d89c0">
                </el-switch>
              </p>
              <el-row type="flex" v-show="customSalary">
                <el-col :span="8">
                  <el-form
                    :model="taskSalary"
                    label-width="80px"
                    size="small"
                    label-position="left"
                    :disabled="!customSalary"
                    :rules="annotatorSalaryRules"
                    ref="annotatorSalary"
                  >
                    <el-form-item label="标注员"></el-form-item>
                    <el-form-item label="正确标注" prop="annotatorCorrect">
                      <el-input v-model="taskSalary.annotatorCorrect" type="number" style="width: 160px"></el-input>
                    </el-form-item>
                    <el-form-item label="错误标注" prop="annotatorWrong">
                      <el-input v-model="taskSalary.annotatorWrong" type="number" style="width: 160px"></el-input>
                    </el-form-item>
                    <el-form-item label="未标注" prop="annotatorOmit">
                      <el-input v-model="taskSalary.annotatorOmit" type="number" style="width: 160px"></el-input>
                    </el-form-item>
                    <el-form-item label="多标注" prop="annotatorUnnecessary">
                      <el-input v-model="taskSalary.annotatorUnnecessary" type="number" style="width: 160px"></el-input>
                    </el-form-item>
                    <el-form-item label="申诉成功" prop="annotatorAppealSuccess">
                      <el-input
                        v-model="taskSalary.annotatorAppealSuccess"
                        type="number"
                        style="width: 160px"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="申诉失败" prop="annotatorAppealReject">
                      <el-input
                        v-model="taskSalary.annotatorAppealReject"
                        type="number"
                        style="width: 160px"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="无效图" prop="annotatorUseless">
                      <el-input v-model="taskSalary.annotatorUseless" type="number" style="width: 160px"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="8">
                  <el-form
                    :model="taskSalary"
                    label-width="80px"
                    size="small"
                    label-position="left"
                    :disabled="!customSalary"
                    :rules="approverTwoSalaryRules"
                    ref="approverTwoSalary"
                  >
                    <el-form-item label="安检员"></el-form-item>
                    <el-form-item label="正确审核" prop="approverTwoCorrect">
                      <el-input v-model="taskSalary.approverTwoCorrect" type="number" style="width: 160px"></el-input>
                    </el-form-item>
                    <el-form-item label="改对框" prop="approverTwoUpdateCorrect">
                      <el-input
                        v-model="taskSalary.approverTwoUpdateCorrect"
                        type="number"
                        style="width: 160px"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="漏框" prop="approverTwoOmit">
                      <el-input v-model="taskSalary.approverTwoOmit" type="number" style="width: 160px"></el-input>
                    </el-form-item>
                    <el-form-item label="改错框" prop="approverTwoUpdateWrong">
                      <el-input
                        v-model="taskSalary.approverTwoUpdateWrong"
                        type="number"
                        style="width: 160px"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="无效图" prop="approverTwoUseless">
                      <el-input v-model="taskSalary.approverTwoUseless" type="number" style="width: 160px"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </div>
            <!--            <div style="width: 804px;">-->
            <!--              <p>-->
            <!--                <span>测试题：</span>-->
            <!--              </p>-->
            <!--              <div style="background: #fff;padding: 12px;border: 1px solid #ddd;border-radius: 4px">-->
            <!--                <div-->
            <!--                  v-for="exam of examList.filter(v => v.status === 2 && v.type === 2)"-->
            <!--                  :key="`exam${exam.id}`"-->
            <!--                  style="display: inline-block;margin-right: 16px;"-->
            <!--                >-->
            <!--                  <input-->
            <!--                    type="checkbox"-->
            <!--                    v-model="examIds"-->
            <!--                    :value="exam.id"-->
            <!--                    style="vertical-align: middle;margin-right: 8px;"-->
            <!--                  />-->
            <!--                  <span>{{ exam.name }}</span>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
          <button type="submit">保存</button>
        </form>
      </div>
      <div class="classinfo">
        <div>
          <div class="chosen-classes">
            <form v-on:submit.prevent="addClass">
              <p>
                <span>类别属性：</span>
                <input v-model="categoryName" required />
              </p>
              <p>
                <span>类别名称：</span>
                <input v-model="className" required />
              </p>
              <button type="submit">添加</button>
            </form>
            <div class="class-content">
              <div
                class="category-content"
                v-for="classification of classifications"
                :key="`chosenclassification${classification.categoryId}`"
              >
                <div class="class-card" v-for="c of classification.classes" :key="`chosenclasses${c.classId}`">
                  <div class="class-info">
                    <span>{{ c.className }} ({{ classification.categoryName }})</span>
                  </div>
                  <div class="class-remove">
                    <img src="@/assets/close.png" @click="unrelateClass(c.classId)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="candidate-class">
            <span>选择已有类别：</span>
            <el-tree
              :data="totalClasses"
              show-checkbox
              node-key="id"
              :default-expanded-keys="defaultExpandedKeys"
              :default-checked-keys="defaultCheckedKeys"
              :props="defaultProps"
              ref="tree"
              style="background: #fafafa"
              @check="checkChange"
            >
            </el-tree>
            <!--            <div v-for="classification of totalClasses" :key="`candidateclassification${classification.categoryId}`">-->
            <!--              <img-->
            <!--                src="@/assets/select-arrow2.png"-->
            <!--                @click="toggleClf(classification.categoryId)"-->
            <!--                :class="shrinkCate.includes(classification.categoryId) ? 'shrink-arrow' : ''"-->
            <!--              />-->
            <!--              <span>{{ classification.categoryName }}</span>-->
            <!--              <div v-if="!shrinkCate.includes(classification.categoryId)">-->
            <!--                <div v-for="c of classification.classes" :key="`candidateclass${c.classId}`">-->
            <!--                  <input-->
            <!--                    type="checkbox"-->
            <!--                    v-model="chosenClasses"-->
            <!--                    :value="c.classId"-->
            <!--                    @click="toggleClass(c.classId, $event)"-->
            <!--                  /><span>{{ c.className }}</span>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
          <button style="position: absolute; bottom: 0; right: 10px" @click="submitTaskClassIds">保存</button>
        </div>
      </div>
      <div class="image-info">
        <el-form ref="form" :model="form" label-width="120px" label-position="left">
          <el-form-item label="图片选择"> </el-form-item>
          <el-form-item label="复用现有任务">
            <el-switch v-model="form.taskReuse"></el-switch>
          </el-form-item>
          <el-form-item label="任务ID">
            <el-input v-model="form.taskIds" :disabled="!form.taskReuse" placeholder="任务ID格式: 1,2,3,4"></el-input>
          </el-form-item>
          <el-form-item label="图片ID">
            <el-input
              type="textarea"
              placeholder="图片ID格式: 1,2,3,4"
              v-model="form.imageIds"
              :disabled="form.taskReuse"
            ></el-input>
          </el-form-item>
          <el-form-item label="类别筛选">
            <el-switch v-model="form.classFilter"></el-switch>
          </el-form-item>
          <el-form-item label="请选择筛选类别">
            <el-cascader
              :disabled="!form.classFilter"
              v-model="form.classIds"
              :options="totalClasses"
              :props="props"
              filterable
              collapse-tags
              clearable
              placeholder="请选择类别"
              ref="cascader"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="复制标注结果">
            <el-switch v-model="form.annoReuse" :disabled="taskTypeId !== 7"></el-switch>
          </el-form-item>
          <el-form-item>
            <div style="height: 40px">
              <button @click="submitTaskImage" type="button">提交</button>
            </div>
          </el-form-item>
        </el-form>
        <el-collapse v-model="collapseIndex">
          <el-collapse-item name="1">
            <template slot="title">*使用说明<i class="header-icon el-icon-info"></i> </template>
            <div>1. 该模块用于提交任务图片, 图片ID可以复用现有任务, 也可以手动输入</div>
            <div>2. 类别筛选为进阶选项, 如果在类别筛选中选择某些类, 那么只有包含这些类别的图片会被添加进任务</div>
            <div>3. 复制标注结果只在任务类型为改类别情况时开放, 勾选状态会将类别筛选中的类别框复制到该任务中</div>
            <div>
              备注: 图片可以分多次提交, 后台进行增量处理, 只增不减, 不会因为后次筛选出图片减少而将存在图片或框删除
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/api.js';
import navigation from '@/components/navigation';
import topnav from '@/components/topnav';
import { categoryMap } from '@/config';
export default {
  data() {
    const validPositiveNum = (rule, value, callback) => {
      if (!value) {
        this.enableSubmitObj[rule.field] = false;
        callback(new Error('字段不能为空'));
      } else if (value.includes('.') && value.split('.').pop().length > 2) {
        this.enableSubmitObj[rule.field] = false;
        callback(new Error('数值精度不得大于小数点后两位'));
      } else if (!(parseFloat(value) > 0)) {
        this.enableSubmitObj[rule.field] = false;
        callback(new Error('数值必须大于0'));
      } else {
        this.enableSubmitObj[rule.field] = true;
        callback();
      }
    };
    const validNegativeNum = (rule, value, callback) => {
      if (!value) {
        this.enableSubmitObj[rule.field] = false;
        callback(new Error('字段不能为空'));
      } else if (value.includes('.') && value.split('.').pop().length > 2) {
        this.enableSubmitObj[rule.field] = false;
        callback(new Error('数值精度不得大于小数点后两位'));
      } else if (!(parseFloat(value) < 0)) {
        this.enableSubmitObj[rule.field] = false;
        callback(new Error('数值必须小于0'));
      } else {
        this.enableSubmitObj[rule.field] = true;
        callback();
      }
    };
    return {
      taskId: null,
      userId: null,
      images: [],
      imageIds: '',
      taskTypes: [],
      industries: [],
      taskTypeId: 0,
      industryId: 0,
      data: '',
      classifications: [],
      totalClasses: [],
      categoryName: '',
      className: '',
      chosenClasses: [],
      shrinkCate: [],
      examList: [],
      examIds: [],
      desc: '',
      taskName: '',
      taskSalary: {},
      customSalary: false,
      enableSubmitObj: {},
      annotatorSalaryRules: {
        annotatorCorrect: [
          {
            validator: validPositiveNum,
            trigger: 'blur',
          },
        ],
        annotatorWrong: [
          {
            validator: validNegativeNum,
            trigger: 'blur',
          },
        ],
        annotatorOmit: [
          {
            validator: validNegativeNum,
            trigger: 'blur',
          },
        ],
        annotatorUnnecessary: [
          {
            validator: validNegativeNum,
            trigger: 'blur',
          },
        ],
        annotatorAppealSuccess: [
          {
            validator: validPositiveNum,
            trigger: 'blur',
          },
        ],
        annotatorAppealReject: [
          {
            validator: validNegativeNum,
            trigger: 'blur',
          },
        ],
        annotatorUseless: [
          {
            validator: validPositiveNum,
            trigger: 'blur',
          },
        ],
      },
      approverTwoSalaryRules: {
        approverTwoCorrect: [
          {
            validator: validPositiveNum,
            trigger: 'blur',
          },
        ],
        approverTwoUpdateCorrect: [
          {
            validator: validPositiveNum,
            trigger: 'blur',
          },
        ],
        approverTwoOmit: [
          {
            validator: validNegativeNum,
            trigger: 'blur',
          },
        ],
        approverTwoUpdateWrong: [
          {
            validator: validNegativeNum,
            trigger: 'blur',
          },
        ],
        approverTwoUseless: [
          {
            validator: validPositiveNum,
            trigger: 'blur',
          },
        ],
      },
      defaultProps: {
        children: 'classes',
        label: 'name',
      },
      defaultExpandedKeys: Object.keys(categoryMap).map(v => parseInt(v, 10)),
      defaultCheckedKeys: [],
      allClassObj: {},
      form: {
        taskReuse: true,
        taskIds: '',
        imageIds: '',
        classFilter: false,
        classIds: [],
        annoReuse: false,
      },
      props: { multiple: true, value: 'id', label: 'name', children: 'classes' },
      collapseIndex: '1',
    };
  },
  components: {
    navigation,
    topnav,
  },
  mounted: function() {
    this.taskId = this.$route.params.id;
    this.getTaskInfoEdit();
    this.getExamList();
  },
  methods: {
    getExamList() {
      api.getExamAdmin().then(res => {
        this.examList = res.data;
      });
    },
    toggleClf(cateId) {
      if (this.shrinkCate.includes(cateId)) {
        this.shrinkCate.splice(
          this.shrinkCate.findIndex(v => v === cateId),
          1,
        );
      } else {
        this.shrinkCate.push(cateId);
      }
    },
    toggleClass(classId, $event) {
      if ($event.target.checked) {
        this.relateClass(classId);
      } else {
        this.unrelateClass(classId);
      }
    },
    getUserTotalClasses() {
      api
        .getUserTotalClasses({ userId: this.userId })
        .then(res => {
          this.totalClasses = res.data.classifications.map(v => {
            return {
              id: v.categoryId,
              name: categoryMap[v.categoryId],
              categoryId: v.categoryId,
              categoryName: v.categoryName,
              classes: v.classes.map(cls => {
                return {
                  ...cls,
                  id: cls.classId,
                  name: cls.className,
                };
              }),
            };
          });
        })
        .catch(() => {});
    },
    getTaskInfoEdit() {
      api
        .getTaskInfoEdit({ taskId: this.taskId })
        .then(res => {
          this.industries = res.data.industries;
          this.taskTypes = res.data.taskTypes;
          this.industryId = res.data.task.industryId;
          this.taskTypeId = res.data.task.taskTypeId;
          this.data = res.data.task.data;
          this.desc = res.data.task.desc;
          this.userId = res.data.task.createId;
          this.examIds = res.data.task.examIds ? res.data.task.examIds : [];
          this.classifications = res.data.task.classifications;
          this.chosenClasses = this.classifications
            .reduce((total, item) => [...total, ...item.classes], [])
            .map(v => v.classId);
          this.getUserTotalClasses();
          this.images = res.data.images;
          this.imageIds = this.images.map(v => Object.keys(v)[0]).join(',');
          this.taskName = res.data.task.taskName;
          this.taskSalary = res.data.taskSalary;
          //[...pre, ...cur.classes.map(v => v.classId)]
          this.defaultCheckedKeys = [];
          this.allClassObj = {};
          this.defaultCheckedKeys = res.data.task.classifications.reduce(
            (pre, cur) => pre.concat(cur.classes.map(v => v.classId)),
            [],
          );
        })
        .catch(() => {});
    },
    addClass() {
      if (
        this.totalClasses.find(v => v.categoryName === this.categoryName) &&
        this.totalClasses
          .find(v => v.categoryName === this.categoryName)
          .classes.find(v => v.className === this.className)
      )
        this.relateClass(
          this.totalClasses
            .find(v => v.categoryName === this.categoryName)
            .classes.find(v => v.className === this.className).classId,
        );
      else
        api
          .addClass({ className: this.className, categoryName: this.categoryName }, this.userId)
          .then(res => {
            this.$notify({
              group: 'foo',
              text: '类别添加成功',
              type: 'custom-blue',
              duration: 1500,
            });
            this.relateClass(res.data.classId);
          })
          .catch(() => {});
    },
    relateClass(classId) {
      api
        .relateClass({ classId, taskId: this.taskId })
        .then(() => {
          this.getTaskInfoEdit();
        })
        .catch(() => {});
    },
    unrelateClass(classId) {
      // api
      //   .unrelateClass({ classId, taskId: this.taskId })
      //   .then(() => {
      //     this.$notify({
      //       group: 'foo',
      //       type: 'custom-blue',
      //       text: '类别删除成功',
      //       duration: 1500,
      //     });
      //     this.getTaskInfoEdit();
      //   })
      //   .catch(() => {});
      this.classifications = this.classifications
        .map(v => {
          return {
            ...v,
            classes: v.classes.filter(cls => cls.classId !== classId),
          };
        })
        .filter(classification => (classification.classes || []).length);
      this.$refs.tree.setChecked(classId, false);
    },
    editTask() {
      if (Object.values(this.enableSubmitObj).some(v => !v)) return;
      api
        .editTask(
          {
            industryId: this.industryId,
            taskTypeId: this.taskTypeId,
            data: this.data,
            examIds: this.examIds,
            imageIds: this.imageIds ? this.imageIds.split(',') : [],
            desc: this.desc,
            taskName: this.taskName,
            taskSalary: this.taskSalary,
          },
          this.taskId,
        )
        .then(() => {
          this.getTaskInfoEdit();
          this.$notify({
            group: 'foo',
            type: 'custom-blue',
            text: '任务信息修改成功',
            duration: 1500,
          });
        })
        .catch(() => {});
    },
    checkChange() {
      const checkedKeys = this.$refs.tree.getCheckedKeys();
      this.classifications = [];
      this.classifications = this.totalClasses
        .map(v => {
          return {
            ...v,
            classes: v.classes.filter(cls => checkedKeys.includes(cls.classId)),
          };
        })
        .filter(classification => (classification.classes || []).length);
    },
    // 新版relateClass和unrelateClass废弃, 前端修改后统一提交
    submitTaskClassIds() {
      api
        .submitTaskClassIds(this.taskId, {
          classIds: this.$refs.tree.getCheckedKeys().filter(v => !this.defaultExpandedKeys.includes(v)),
        })
        .then(() => {
          this.$message.success('任务类别已更新');
          this.getTaskInfoEdit();
        })
        .catch(() => {});
    },
    submitTaskImage() {
      let { taskReuse, taskIds, imageIds, classFilter, classIds, annoReuse } = this.form;
      if (taskReuse) {
        imageIds = [];
        taskIds = taskIds.replace(/[\r\n]/g, '');
        if (taskIds.match(/[^\d,]+/g)) {
          this.$message.warning('任务ID列表存在非逗号和数字符号');
          return;
        }
        taskIds = taskIds.split(',').reduce((pre, cur) => {
          if (cur) {
            pre.push(parseInt(cur));
          }
          return pre;
        }, []);
        if (!taskIds.length) {
          this.$message.warning('任务ID不能为空');
          return;
        }
      } else {
        taskIds = [];
        imageIds = imageIds.replace(/[\r\n]/g, '');
        if (imageIds.match(/[^\d,]+/g)) {
          this.$message.warning('图片ID列表存在非逗号和数字符号');
          return;
        }
        imageIds = imageIds.split(',').reduce((pre, cur) => {
          if (cur) {
            pre.push(parseInt(cur));
          }
          return pre;
        }, []);
        if (!imageIds.length) {
          this.$message.warning('图片ID不能为空');
          return;
        }
      }
      if (classFilter && !classIds.length) {
        this.$message.warning('筛选类别不能为空');
        return;
      }
      if (!classFilter) classIds = [];
      if (annoReuse && !this.classifications.length) {
        this.$message.warning('复用标注结果前请先为任务指定类别');
        return;
      }
      const taskImageOptions = {
        taskIds,
        classIds: classIds.map(v => v[1]),
        imageIds,
        taskReuse,
        classFilter,
        annoReuse,
      };
      api
        .submitTaskImages(this.taskId, { taskImageOptions })
        .then(() => {
          this.$message.success('图片提交成功');
          this.form = {
            taskReuse: true,
            taskIds: '',
            imageIds: '',
            classFilter: false,
            classIds: [],
            annoReuse: false,
          };
          this.getTaskInfoEdit();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
p {
  margin: 0px;
  padding: 12px 0px;
}
select {
  width: 272px;
  height: 32px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background-image: url('~@/assets/select-arrow.png');
  background-repeat: no-repeat;
  background-position: right;
  background-position-x: 250px;
  background-size: 14px;
  color: #595959;
  padding: 7px 20px 7px 12px;
  font-size: 14px;
  line-height: 100%;
  background-color: #fff;
  margin-left: 6px;
}
input {
  box-sizing: border-box;
  height: 32px;
  margin-left: 6px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  font-size: 14px;
  padding: 0px 12px;
}
input[type='checkbox'] {
  width: 16px;
  height: 16px;
  margin: 0px;
  padding: 0px;
  border: none !important;
  background-size: 16px;
  background-color: #fff;
  appearance: none;
  -webkit-appearance: none;
  -o-appearance: none;
  -moz-appearance: none;
  border: 1px solid #ffad01;
  border-radius: 2px;
  outline: none;
  background-image: url('~@/assets/uncheck.png');
}
input[type='checkbox']:checked {
  background-image: url('~@/assets/checked.png');
}
input[type='checkbox']:focus {
  outline: none;
}
#image-path {
  width: 686px;
}
.baseinfo {
  background: #fafafa;
  border-radius: 4px 4px 0px 0px;
  margin: 24px 0px 12px;
  padding: 24px 36px;
  box-sizing: border-box;
  position: relative;
}
button {
  position: absolute;
  right: 36px;
  height: 38px;
  width: 65px;
}
.baseinfo form button {
  bottom: 24px;
}
.classinfo {
  position: relative;
  margin: 0px;
  background: #fafafa;
  border-radius: 4px 4px 0px 0px;
  padding: 24px 36px;
}
.classinfo > div {
  position: relative;
  height: 100%;
  width: 100%;
}
.classinfo > div > div {
  display: inline-block;
}
.classinfo div form button {
  right: 0px;
  top: 8px;
}
.classinfo div form input {
  width: 200px;
  height: 32px;
  margin-left: 6px;
}
.classinfo div form p {
  margin: 0px 60px 23px 0px;
  display: inline-block;
}
.class-content {
  border-top: 1px dashed #bbbbbb;
}
.category-content {
  border-bottom: 1px dashed #bbbbbb;
  padding-bottom: 23px;
}
.class-content .category-content:last-child {
  border: none;
}
.class-card {
  display: inline-block;
  margin: 12px 24px 0px 0px;
  line-height: 100%;
  font-size: 14px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  background: #ffffff;
}
.class-card div {
  padding: 9px 12px;
  display: inline-block;
}
.class-card .class-remove {
  padding: 9px;
  margin-top: -1px;
  /*border-left: 1px solid #dddddd;*/
}
.class-card img {
  width: 14px;
  height: 14px;
}
.chosen-classes {
  position: relative;
  vertical-align: top;
  min-height: 450px;
  width: 75%;
}
.chosen-classes button {
  margin: 0px;
}
.candidate-class {
  height: 90%;
  position: absolute;
  left: 80%;
  width: 20%;
  overflow: scroll;
}
.candidate-class > div {
  font-size: 16px;
}
.candidate-class > span {
  display: inline-block;
  font-size: 16px;
  margin: 4px 0px 24px;
}
.candidate-class > div > img {
  width: 16px;
  margin-right: 4px;
}
.shrink-arrow {
  transform: rotate(180deg);
}
.candidate-class > div > span {
  display: inline-block;
  margin-bottom: 15px;
}
.candidate-class > div > div > div {
  font-size: 14px;
  margin-bottom: 16px;
}
.candidate-class > div > div > div > span {
  vertical-align: text-top;
  display: inline-block;
  margin: -2px 0px 0px 8px;
  line-height: 16px;
}
.edittask-container {
  padding: 84px 50px 0px 301px;
}
textarea {
  resize: none;
  min-height: 104px;
  width: 720px;
  box-sizing: border-box;
  margin-left: 6px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  font-size: 14px;
  padding: 9px 12px;
}
/deep/.el-switch__label.is-active {
  color: #5d89c0;
}
/*.el-form-item {*/
/*  margin-bottom: 2px;*/
/*}*/
.image-info {
  background: #fafafa;
  border-radius: 4px 4px 0px 0px;
  margin: 24px 0px 12px;
  padding: 24px 36px;
  box-sizing: border-box;
  position: relative;
}
/deep/.el-textarea textarea {
  height: 150px !important;
}
/deep/.el-collapse-item__header {
  color: #f56c6c;
  background: #fafafa;
}
/deep/.el-collapse-item__arrow {
  color: #000000;
}
</style>
